import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { ApprovalMetrics } from "./types";

export const APPROVAL_METRICS_QUERY_KEY = ["admin", "venues", "approval-metrics"] as const;

async function fetchApprovalMetrics(): Promise<ApprovalMetrics> {
  return httpClient<ApprovalMetrics>("/api/admin/venues/approval-metrics?period=week");
}

export function useApprovalMetrics() {
  return useQuery({
    queryKey: APPROVAL_METRICS_QUERY_KEY,
    queryFn: fetchApprovalMetrics,
    staleTime: 60_000,
  });
}
